import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function EventbriteComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('eventbrite')} />
}
